import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getLeakFile = params => common.requestRaw(apiUrl + 'Exam/LeakFile', params, 'get');
export const deleteLeakFile = params => common.requestRaw(apiUrl + 'Exam/LeakFile', params, 'delete');



// WEBPACK FOOTER //
// ./src/script/libs/leakFileLib.js